import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export const Intro = () => (
    <section
        data-testid="intro-section"
        className="py-20 md:py-32 px-5 sm:px-8 lg:px-12"
    >
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
            <div className="lg:col-span-7">
                <Reveal>
                    <Eyebrow>Creative. Strategic. Savv.</Eyebrow>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-4 font-serif-ed text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-[#F1F1EF]">
                        Your business deserves{" "}
                        <span className="italic text-[#D3A0A7]">
                            to be seen.
                        </span>
                    </h2>
                </Reveal>
                <Reveal delay={0.2}>
                    <p className="mt-6 max-w-lg text-base md:text-lg leading-relaxed text-[#A9A6A0]">
                        We turn ideas into eye-catching brands, content, and
                        marketing that make people stop scrolling — and remember
                        you.
                    </p>
                </Reveal>
                <Reveal delay={0.3}>
                    <a
                        href="#contact"
                        data-testid="intro-cta-link"
                        className="group mt-8 inline-flex items-center gap-2 font-semibold text-[#D3A0A7] link-underline"
                    >
                        Let&apos;s Make Something
                        <ArrowRight
                            size={17}
                            className="transition-transform duration-300 group-hover:translate-x-1.5"
                        />
                    </a>
                </Reveal>
            </div>
            <div className="lg:col-span-5">
                <Reveal delay={0.15}>
                    <motion.div
                        whileHover={{ rotate: 0, scale: 1.02 }}
                        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                        className="relative rounded-[1.75rem] overflow-hidden rotate-[2.5deg] shadow-[0_30px_60px_-20px_rgba(12,12,12,0.3)] border-4 border-[#F1F1EF] bg-[#EAF1F7] p-3"
                    >
                        <img
                            src="/images/notebook.png"
                            alt="Savv Media flat lay — big ideas, real results"
                            data-testid="intro-notebook-image"
                            className="w-full h-auto rounded-2xl block"
                            loading="lazy"
                        />
                    </motion.div>
                </Reveal>
            </div>
        </div>
    </section>
);
